const concat = "<br />"

export const seprateAssetDetails = {

  faq: [
    {
      id: "1",
      question: "Understand Bonds",
      answer: [
        {
          question: "1. What is a Bond?",
          answer: "A bond is an instrument through which corporates borrow money from other institutions and retail investors. The investors earn a fixed rate of interest on the bond at defined intervals and the principal amount is repaid on maturity.",
        },
        {
          question: "2. What is an unlisted bond?",
          answer: "Bonds that are not listed on the exchange are called Unlisted bonds. Even though these bonds are not listed they can be bought and sold in the private market. Though it is an Unlisted bond, it will still be visible in your DEMAT account after investment.",
        },
        {
          question: "3. What is a coupon?",
          answer: "A coupon is the rate of interest that is paid on the investment value of the bond.",
        },
        {
          question: "4. What is the risk associated?",
          answer:"The three major risks associated with Bonds:" + concat + concat +
          "<b>Credit Risk</b>- This refers to an event where the borrower is unable to repay either the full or part of the borrowed amount. This risk can be mitigated if the bond is secured which means that there will be a security cover (collateral) available to safeguard the interests of the lender." + concat + concat +
    
          "<b> Liquidity risk</b>-This risk refers to the inability to sell and liquidate the bond when you need the funds. Bonds are ideal if the investment horizon matches the maturity of the bond since liquidity in bonds is limited if they need to be sold before the maturity date. Though bonds are traded, the volume remains low." + concat + concat +
          
          "<b> Interest rate risk</b>- This risk refers to the change in the interest rates once the bonds are  purchased. If the interest rate goes up after the bonds are purchased, there will be a Mark to Market loss on the investment." + concat + concat +
    
          "Other risks include Reinvestment risk and Fraud risk."
        },
        {
          question: "5.What are the important bond terminologies? ",
          answer: "Below are some of the important terms used to understand the bond offering:" + concat +
          "<ul>" +
    
          "<li>  <b>Yield</b>:The Yield to Maturity or the YTM reflects the return that the investor will earn if he holds the bond till maturity.</li>"  +
          "<li>  <b>Size of the Issue</b>: A large issue size attracts participation from various types of investors and thus, evaluation and diligence are generally more detailed.</li>" +
          "<li>  <b>Credit Rating</b>: Bonds are usually rated by Credit Rating Agencies like CRISIL, ICRA, CARE, etc. The higher the rating, the less risky the bond is. AAA is generally considered the top rating, and D is the lowest.</li>" +
          "<li>  <b>Issue Type</b>: An issue type can be either public or private.</li>" +
          "</ul>"
        },
        {
          question: "6. What is the difference between coupon rate and Yield?",
          answer:
            "The Coupon is the rate of interest that the investor will receive over the period of the bond. Whereas, YTM refers to the return that the investor will earn if he holds the bond till maturity. When the Price of the bond is equal to the Face Value, the Coupon rate and the yield would be the same. When Price is greater than Face value, the Coupon is greater than the yield and vice versa. ",
        },
        {
          question: "7. Is face value same as the market price?",
          answer:
            "No, Face value is the price of the security when it was first issued. All the interest payments are calculated based on face value. However, the market price, maybe higher or lower than the face value, based on prevailing market conditions.",
        },
        {
          question: "8. Are bonds secured?",
          answer:
            "Bonds can be secured as well as unsecured. Secured bonds are safer since they are secured with a charge on the issuer’s assets.",
        },
        {
          question: "9. Is a DEMAT account mandatory to invest in bonds?",
          answer:
            "Yes. The DEMAT account is mandatory since the bonds will be credited directly to your DEMAT account.",
        },
        {
          question: "10. What documents do I need to invest in bonds?",
          answer:
            "Minimum KYC documents like PAN, address proof, bank account details, and Demat details are required for onboarding.",
        },
        {
          question: "11. How is the interest received taxed?",
          answer:
           "The interest received will be taxed as per your income tax slab. TDS will be deducted before the interest amount gets credited to your DEMAT linked Bank account."
        },
      ],
    },
    {
      id: "2",
      question: "About MLDs",
      answer: [
        {
          question: "1. What are MLDs?",
          answer: "Market Linked Debentures (MLDs) are debt instruments that offer returns linked to the performance of an underlying financial market index." + concat + concat + 
          "MLD’s are a type of debt instrument issued by companies to raise funds from the public. They combine the features of Traditional debentures with investment characteristics linked to the performance of the financial markets or specific assets like stocks, indices or commodities."
        },
        {
          question: "2. Why have we not come across MLDs before?",
          answer: "MLDs were mostly accessible to Institutions and High-net-worth individuals due to their complexity and tailored nature. Additionally, the ticket size to investment was often out of reach to a lay investor."
        },
        {
          question: "3. What are the types of MLDs?",
          answer: "There are two main types of MLD’s." + concat +
            "<b>Principal protected MLD’s</b> : These MLD’s guarantee the repayment of the principal amount irrespective of the market performance. They offer downside protection to investors in case of adverse market conditions." + concat + concat +
            "<b>Non Principal Protected MLD’s</b> : These MLD’s do not guarantee the repayment of the principal amount and expose investors to market risk. They offer potentially higher returns than the principal protected MLD’s but also carry a risk of capital loss."
        },
        {
          question: "4. What are the main Risks of an MLD?",
          answer: "Market risk: The returns on the MLD depend upon the performance of the underlying. Although the Market risk is reduced compared to the risk of the underlying since usually, the principal is protected. On the other hand, if the underlying outperforms significantly, that may not translate into gains for the MLD since there would be a cap on the return." + concat + concat +
            "<b>Credit Risk:</b> : MLDs are issued by Banks/ NBFCs and it is important to consider the financial condition of the issuer before investing. This risk should be assessed in the same way as when investing in a regular bond issued by the issuer." + concat + concat +
            "<b>Liquidity Risk:</b> : MLD’s may not have an active secondary market, making it challenging for the investors to sell their holdings before maturity. MLDs are very customized and the returns on the MLD are not fully realized till the maturity of the product. For these reasons, MLDs are usually Buy and Hold investments."
        },
        {
          question: "5. How are MLDs Taxed?",
          answer: "Any gains arising due to sale, maturity or redemption will be treated as Short term capital gains, irrespective of the holding period and listing status and hence will be taxed as per the investors tax slab."
        },
        {
          question: "6. Would there be an TDS on the coupon of MLD?",
          answer: "Yes, the Coupon at the end of the maturity of the MLD would be paid after deducting tax on the same at the rate of 10% as per Section 193."
        },
        {
          question: "7. Do MLDs have a Credit Rating?",
          answer: "An MLD may or may not be Credit Rated. Although, Credit Rating is mandatory if the MLD has to be listed on the stock exchanges."
        },
        {
          question: "8. Are MLDs secured?",
          answer: "Just like an NCD, an MLD may or may not be secured."
        },
        {
          question: "9. Are MLDs Regulated?",
          answer: "MLDs are a form of debentures and hence get regulated by SEBI."
        },
        {
          question: "10. Is a DEMAT account mandatory to Invest in an MLD?",
          answer: "Yes, a DEMAT account is mandatory since the MLD will be credited directly into your DEMAT account."
        },
      ]
    },
    {
      id: "3",
      question: "About MLD",
      answer: [
        {
          question: "1. What is the issue date and the maturity date of the MLDs?",
          answer: "The MLD issue will be open for investors on Bidd from 11th Aug’23 to 30th Aug’23 and the maturity date is 31st Aug’25. The primary MLD issue date is 11th Aug’23."
        },
        {
          question: "2. What is the Underlying in this MLD?",
          answer: "The underlying in this MLD is the Nifty 50 Index with a participation ratio of 1.0x. This means that if the Nifty returns are 20%, the returns on the MLD would also be 20%."
        },
        {
          question: "3. What are the Minimum assured and the Maximum returns?",
          answer: "The Minimum assured returns  would be 14% and the maximum returns will be 30%. The returns are calculated on the Face Value of ₹1,00,000."
        },
        {
          question: "4. Which dates will be considered for calculating the returns of Nifty?",
          answer: "The Nifty Returns will be calculated based on the Initial Fixing Level and the Final Fixing Level. The date of the Initial Fixing Level is 31st Aug’23 and the Final Fixing level would be average of the levels of the Nifty 50 Index as on 26th Jun’25 & 31st Jul’25."
        },
        {
          question: "5. When will I receive the coupon (returns) on the MLDs?",
          answer: "The coupon will be realised at the Maturity of the MLD."
        },
        {
          question: "6. Is the MLD listed, secured and Credit Rated?",
          answer: "The MLD will be listed on BSE within 4 trading days of the Primary issue, is secured by loans receivable of IFSL and is rated CARE PP MLD A+ Stable."
        },
      ]
    },
    {
      id: "4",
      question: "About InCred Finance",
      answer: [
        {
        question: "1. What is the business of Incred Financial Services Limited (IFSL)?",
        answer: "InCred Financial Services Limited is a Non-Banking Financial Corporation having segments such as Personal Loan, Student Loan, School Financing & LAP, Anchor & Escrow backed lending & Lending to Financial Institutions."
      },
      {
        question: "2. Who are the promoters of IFSL?",
        answer: "IFSL was founded by Mr. Bhupinder Singh (Founder & Group CEO) and is backed by marquee investors like KKR Singapore, Teachers retirement of Texas, Abu Dhabi Investment Authority , Moore Strategic Ventures and more."
      },
      {
        question: "3. Is IFSL Rated?",
        answer: "InCred Finance has a long-term rating of A+ by CRISIL & CARE with a stable Outlook."
      },
      {
        question: "4. What is the AUM of IFSL?",
        answer: "The AUM at the end of FY23 of IFSL is Rs. 6,062 crores with the following split:" + concat +
          "Personal Loans: Rs. 2,550 Crs." + concat +
          "Student Loans: Rs. 1,038 Crs." + concat +
          "School Financing & LAP: Rs. 486 Crs." + concat +
          "Anchor & Escrow backed lending: Rs. 1,255 Crs." + concat +
          "Lending to Financial Institutions: Rs. 608 Crs." + concat +
          "Wholesale lending: Rs. 124 Crs."
      },
      {
        question: "5. What is the % of Secured and Unsecured lending?",
        answer: "The secured book of IFSL stands at 40% and unsecured at 60%."
      },
      {
        question: "6. What is the profitability of IFSL?",
        answer: "IFSL has been profitable since the first year of operation in 2017. For FY23, the PAT stands at Rs. 120 Crs."
      },
      {
        question: "7. What is the extent of Bad loans (NPAs) of IFSL?",
        answer: "The NPAs of IFSL as on FY23 are relatively low. GNPA : 2.1% NNPA : 0.9%"
      },
      {
        question: "8. How leveraged is IFSL? / What is the debt to equity Ratio of IFSL?",
        answer: "IFSL is leveraged 1.6 times."
      },
      {
        question: "9. What is the Net Interest margin of IFSL?",
        answer: "IFSL operates at a healthy NIM of 9.6%."
      },
      {
        question: "10. What is the Capital Adequacy ratio? ",
        answer: "As of March 2023, The CRAR is 33.4%."
      },
      ]
    },
    { 
    id: "5",
    question: "About the IPO Process",
    answer: [
      {
        question: "1. How does an IPO application through UPI work?",
        answer: "Public issue application using UPI is a digital mode to apply for IPO. An overview of the process is as follows :" + concat +
          `<ul>
            <li>Create a UPI ID and PIN using any of the UPI enabled mobile application</li>
            <li>Go to any platform offering NCD IPO and enter your UPI ID along with bid details</li>
            <li>Accept the request to block the funds for the amount you have bid by entering your UPI PIN in the mobile application like Google Pay of PhonePe.</li>
            <li>The money shall be blocked and shall be automatically remitted to the Bank, in case of allotment.</li>
           <ul>`
      },
      {
        question: "2. Can I use an existing UPI ID for applying in public issues?",
        answer: "Yes. The existing UPI ID can be used"
      },
      {
        question: "3. Which are the list of supported UPI Apps?",
        answer: "The National Payments Corporation of India has permitted 24 UPI apps for IPO." + concat +
          "<b>Here is the list of those 24 apps and their handles." + concat + concat +
          "<u>Click here to know more</u>" + concat + concat + 
          "The total length of the UPI ID does not exceed 45 characters (e.g. the UPI ID XYZ@UPI is 7 characters)."
      },
      {
        question: "4. How to accept the UPI payment mandate?",
        answer: "Your bank through which UPI ID was created will send you an SMS requesting approval of the payment via UPI. You can go to the respective UPI app and approve the payment. By approving the payment, you are accepting the mandate."
      },
      {
        question: "5. What if I erroneously decline the request to block funds?",
        answer: "You can re-initiate a new transaction through the Bidd platform."
      },
      {
        question: "6. What is the per application limit to apply for ASBA through UPI?",
        answer: "NPCI has set a transaction limit of 5 lakhs in the UPI-based payments on the instant   inter-bank fund transfer mechanism. Hence, you can't invest more than RS. 5 lakhs."
      },
      {
        question: "7. Can I Invest more than 5 lakhs in the NCD IPO?",
        answer: "Yes, under the HNI category for investment you can apply for an investment amount greater than 10 Lakhs.  The process to apply under HNI category is offline, and investors have to fill ASBA application form and courier it to the Bidd office. For more details please reach out to us at connect@biddeasy.com"
      },
      {
        question: "8. What happens if I do not get any shares under the public issue process for applications made using UPI for payment?",
        answer: "In case you do not get any share allotment, the amount blocked in your account will be released."
      },
      {
        question: "9. How to find DP ID and Client ID?",
        answer: "You can find your DP ID and Client ID in the profile section of your broking account with platforms like Zerodha, ICICI Direct, Angel Broking etc."
      },
      {
        question: "10. If my application gets rejected, when will my fund be released?",
        answer: "After you subscribe to an IPO, ASBA blocks the application amount in your bank account. In the case your IPO application gets rejected, the amount will be released within 1 or 2 working days."
      },
      {
        question: "11. Where can I get more details about  IPO applications through UPI?",
        answer: "You can visit NPCI website for more details <a href='https://www.npci.org.in/what-we-do/ipo/faqs'>https://www.npci.org.in/what-we-do/ipo/faqs</a>"
      },
      {
        question: "12. Why was my application rejected? ",
        answer: "There could be multiple reasons. Some of the common reasons are as follows:" +
        `<ul>
        <li>The applicant gives an invalid or incorrect DP ID / Client ID</li>
        <li>The PAN given in the IPO application is not matching with the PAN associated with the given Demat account.</li>
        <li>The given Demat account number is wrong.</li>
        <li>The given Demat account is inactive.</li>
        <li>If the Demat account is not accessed for a long time, the Demat account becomes Dormant. The maximum duration Demat account can remain unused before it becomes dormant will be mentioned in an agreement made with DP. By paying reactivation fees to your DP, the Demat account can be reactivated.</li>
        <li>If the UPI mandate is not accepted within 48 hours of placing the application</li>
        <li>The given UPI handle is invalid</li>
         <ul>`
      },
      {
        question: "13. How to accept the UPI payment mandate?",
        answer: "Once you submit your IPO application, your Bank will send you an SMS requesting    approval of the payment via UPI. You can go to the respective UPI app and approve the payment. By approving the payment, you are accepting the mandate."
      },
      {
        question: "14. How do I know my allotment status?",
        answer: "Once the securities are allotted in an IPO, investors will be informed via email and SMS. To check allotment status, investors can visit the registrar’s website or BSE/NSE website. By providing your application number and PAN, you can check the allotment status." + concat + concat +
        "If you have applied for an IPO via Bidd, you can check your allotment status on our platform in the IPO order page under Order history."
      },
    ]
  },    
    {
      id: "6",
      question: "About Liquidation Program",
      answer: [
        {
        question: "1. Can I liquidate my MLD before maturity?",
        answer: "'Anytime Liquidity' feature offers liquidity to investors anytime starting from 7 working days after the close of an issue, until its Maturity. Once the request for Liquidation is placed on the portal, we will complete the transaction within Seven working days. You can request for liquidation anytime by clicking the ‘Liquidate’ button in the portfolio."
      },
      {
        question: "2. At what price would the MLD be liquidated?",
        answer: "The latest mark to market price per unit is refreshed within 1 working day of the request for liquidation being placed. The liquidation will happen at this price minus a fee of 2%."
      },
      {
        question: "3. How will the process of Liquidation work?",
        answer: "On confirmation by the investor, liquidity sale transaction will be processed within 7 working days thereafter." + concat +
        "Liquidity sale will be a 2-step process:" + concat +
        "a. On platform transaction" + concat +
        "b. Off platform transaction" + concat +
        "Both the steps need to be completed to ensure the liquidity sale transaction is fully completed. Partial completion will lead to partial liquidity sale transaction. The investment would be liquidated but not paid out until the full completion of the liquidity sale process."
      },
      {
        question: "4. Are there any charges or fees for liquidation?",
        answer: "Yes, there is a 2% fee which will be applied to the latest market to market price per unit."
      },
      {
        question: "5. Is my Principal protected if I exit the investment before maturity?",
        answer: "No. The principal is protected only if the investor stays invested till the tenure of the product."
      },
      {
        question: "6. Is it possible to partially liquidate my investments or must I redeem the full amount at once?",
        answer: "You have the flexibility to partially liquidate your investments or redeem the entire units at once, depending on your liquidity needs. During the liquidation process, you can specify the quantity of MLDs you wish to redeem."
      }
      ]
    },
    {
      id: "7",
      question: "About Pricing",
      answer: [
        {
        question: "1. How does the value of the MLD change during the tenure of the product?",
        answer: "An MLD product can be divided into 2 parts, an Equity or Market Component, and a Debt Component. Simplistically, you can say that an MLD is a hybrid product with some amount invested in the Market and some amount invested in Debt. The returns from an MLD are a combination of the returns of two components." + concat + concat + 
        "The Debt Component will grow steadily over the tenure of the MLD and the Market Component’s returns will vary based on the Underlying Market’s (in this case Nifty 50 Index) returns. Taken cumulatively, the price of the MLD is determined."
      },
      {
        question: "2. Market has gone up by 10% in six months, but my MTM is lower than that. Why?",
        answer: "The price of an MLD product is influenced by the performance of its Market Component, which is linked to the Underlying Market (e.g., Nifty 50 Index). However, the Market Component's movement is always less than that of the Underlying Market until the maturity date due to the hybrid nature of the product." + concat + concat + 
        "As the MLD approaches maturity, the difference between the returns of the Market Component and the Underlying Market diminishes. On the Maturity Date, this difference becomes zero, and the MLD's returns match the stated values at the time of purchase." + concat + concat + 
        "In summary, while the overall direction of the MLD's returns and the Underlying Market's returns is the same, there will be some variance in returns until maturity, but they align completely on the Maturity Date."
      },
      {
        question: "3. The MLD is Principal Protected, then why has the value of my MLD become Negative during the tenure of the MLD?",
        answer: "An MLD (Market Linked Debenture) consists of two parts: the Equity or Market Component, and the Debt Component. The MLD's returns are a combination of these components. The Debt Component grows steadily over time, while the Market Component's returns depend on the performance of the Underlying Market (e.g., Nifty 50 Index)." + concat + concat +
        "Initially, there may be some variance between the MLD's returns and the Underlying Market due to its hybrid nature. This difference is more pronounced when the MLD has a longer time to maturity, but it diminishes as the maturity date approaches." + concat + concat +
        "In the early days, if the Underlying Market experiences a significant decline, the Market Component's value in the MLD may temporarily fall, causing negative overall returns. However, on maturity, the Market Component can never be negative, and at worst, it can be zero." + concat + concat +
        "Over time, the Market Component's negative impact lessens, while the Debt Component continues to grow steadily. This results in the MLD's returns steadily improving, eventually reaching the stated minimum assured returns (14% in this case) and 100% principal protection upon maturity."
      }
      ]
    },
    {
      id: "8",
      question: "Referral Program",
      answer: [
        {
        question: "1. Is there any referral program and will I get rewarded for referring someone?",
        answer: "Yes, we do have a referral program. Please visit the Refer tab to know more about the program."
      }
      ]
    },
    {
      id: "9",
      question: "Other FAQs",
      answer: [
        {
        question: "1. How do I get started and what are the steps to invest?",
        answer: "You can login to " +
        `<a href=${process.env.REACT_APP_URL_ENDPOINTS} target="_blank">www.biddeasy.com</a> using your Mobile Number and Email Id. You can complete the KYC on the platform. Post that, you would be eligible to invest.` + concat + concat +
        "Step 1: Once the issue is live, you can select the amount you would wish to invest." + concat +
        "Step 2: Review and sign the documents." + concat +
        "Step 3: Complete your payment. Your investments will reflect in your DEMAT account in 3 working days."
      },
      {
        question: "2. Is the investment process digital?",
        answer: "Yes, the investment process is completely digital."
      },
      {
        question: "3. Who can Invest on Bidd?",
        answer: "Anyone who is above 18 years of age and has KYC verified can invest through the Bidd platform."
      },
      {
        question: "4. What documents do I need to invest on Bidd?",
        answer: "Minimum KYC documents like PAN, Address proof , bank account details and DEMAT details are required for onboarding."
      },
      {
        question: "5. Where can I see the market value of MLD?",
        answer: "You can see the value of MLD by logging on to www.biddeasy.com in the portfolio section."
      },
      {
        question: "6. Can NRI’s Invest in IFSL MLD?",
        answer: "NRIs can invest provided they have an NRO DEMAT account."
      },
      {
        question: "7. Are there any Charges to invest in MLD?",
        answer: "No, there are no charges to invest in an MLD."
      },
      {
        question: "8. Where can I view my investments on Bidd?",
        answer: "<a href='/platform/#/'>Click here to view your investments.</a>"
      },
      {
        question: "9. Is Bidd regulated?",
        answer: "Yes, Bidd is compliant with applicable regulatory norms."
      },
      {
        question: "10. Where can I track my investments on Bidd?",
        answer: "Once the transaction is processed, you can view your investment in your DEMAT account. The investment may take 3-5 working days to reflect in your DEMAT. In case, you can't find your investment details in DEMAT, please reach out to us and our support team will assist you further."
      },
      {
        question: "11. In case of any query, how can I reach out to Bidd support?",
        answer: "If you have any query, please feel free to email us on connect@biddeasy.com or contact us on +91 8591871028 or +91 8928250817."
      }
      ]
    }
  ],
};
